import React, { FunctionComponent, useCallback, useMemo } from 'react';

import { NOTIFICATION_TYPES } from '@savgroup-front-common/constants';
import { Notification } from '@savgroup-front-common/types';

import { toast } from '../../../atoms/Toast';

import ToastsProviderContext from './ToastsProvider.context';

const ToastsProvider: FunctionComponent<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  const pushNotifications = useCallback((notifications: Notification[]) => {
    notifications.forEach(({ children, notificationType }) => {
      if (children !== null) {
        switch (notificationType) {
          case NOTIFICATION_TYPES.ERROR:
            toast.error(children);
            break;
          case NOTIFICATION_TYPES.ALERT:
            toast.warn(children);
            break;
          case NOTIFICATION_TYPES.INFO:
            toast.info(children);
            break;
          case NOTIFICATION_TYPES.SUCCESS:
            toast.success(children);
            break;
          default:
            break;
        }
      }
    });
  }, []);

  const value = useMemo(
    () => ({
      pushNotifications,
    }),
    [pushNotifications],
  );

  return (
    <ToastsProviderContext.Provider value={value}>
      {children}
    </ToastsProviderContext.Provider>
  );
};

export default ToastsProvider;
